import { z } from 'zod';

export const smriqCredentialSchema = z.object({
    api_key: z.string().min(20, 'API key must be at least 20 characters').max(1024),
    division: z.string().min(1, 'Division is required').max(255),
});

export type SmriqCredentialFormInput = z.input<typeof smriqCredentialSchema>;
export type SmriqCredentialFormOutput = z.output<typeof smriqCredentialSchema>;
